<template>
  <v-card>
    <mobile-money-accounts-details :mobilemoney="account" />
  </v-card>
</template>
<script>
import MobileMoneyAccountsDetails from "./details.vue";

export default {
  components: { MobileMoneyAccountsDetails },
  props: {
    title: { default: "account details" },
    hideActions: { type: Boolean, default: false },
    id: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      account: null,
      isEditing: false,
    };
  },
  mounted() {
    // eslint-disable-next-line arrow-parens
    this.$http.get(`/api/v1/userMMAccounts/${this.id}`).then((account) => (this.account = account));
  },

  watch: {
    dataaccount(newaccountData) {
      return (this.account = newaccountData);
    },
  },
};
</script>
